import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { centralizedHost } from "~/Utils";

interface PrivacyPolicyTabOneResponse {
  id: string;
  title: string;
  tab_title_english: string;
  tab_title_malay: string;
  tab_title_mandarin: string;
  body: string;
  published?: boolean;
  pdf_url: string;
  project_airport_id_1: any;
  created_by?: string;
  last_modified_by?: string;
}

// Edit API call
const fetchPrivacyPolicyTabOne = async (id?: string): Promise<any> => {
  try {
    if (id) {
      // Fetch specific record by ID
      const response = await axios.get(`${centralizedHost}/api/privacy-policy/tab-1/${id}`);
      return response.data[0];
    }
  } catch (error) {
    console.error("Error fetching privacy policy tab one:", error);
    return null;
  }
};

const usePrivacyPolicyTabOne = (
  id?: string,
  options?: UseQueryOptions<PrivacyPolicyTabOneResponse, DefaultError, PrivacyPolicyTabOneResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<PrivacyPolicyTabOneResponse, DefaultError> => {
  return useQuery<PrivacyPolicyTabOneResponse, DefaultError, PrivacyPolicyTabOneResponse, QueryKey>(
    {
      queryKey: ["privacyPolicyTabOne", id],
      enabled: false,
      queryFn: () => {
        return fetchPrivacyPolicyTabOne(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { usePrivacyPolicyTabOne };
